export default __webpack_public_path__ + "static/background_img-bec8fc31d6288fd95d95562a34555cf4.jpg";